"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "forlimpopoli": {
    "593c0722": [{
      "hkey": "8e735abd",
      "slug": "sant-andrea-in-rossano",
      "name": "Sant'Andrea in Rossano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "8e735abd",
      "slug": "sant-andrea-in-rossano",
      "name": "Sant'Andrea in Rossano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;